// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"ShoppingListModal_modalRoot__1vXfU","modalTop":"ShoppingListModal_modalTop__3lRND"};